import React from 'react';

import { TerrainModel } from '../../../../../../viewer/elements/terrain-model';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { AssetHeader } from '../../components/asset-blocks/asset-header';

type Props = {
  asset: TerrainModel;
};

const TerrainModelHeader = (props: Props) => {
  const [_, refresh] = useNonce();

  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  return <AssetHeader asset={props.asset} name={props.asset.name} />;
};

export { TerrainModelHeader, Props as TerrainModelHeaderProps };
